import { FC, useMemo } from 'react';

import { LuMoveUpRight } from 'react-icons/lu';
import { cn } from 'utils/helpers';
import { ExportIcon, TagIcon, TrashIcon } from 'ui/components/icon';

import Button from '../Button';

interface PROPS {
  ids: string[];
  onDelete?: () => void;
  onUpdate?: () => void;
  onExport?: () => void;
  onMove?: () => void;
}

const FloatingBar: FC<PROPS> = ({
  ids,
  onDelete,
  onUpdate,
  onExport,
  onMove,
}) => {
  const show = useMemo(
    () => !!ids.length && (!!onDelete || !!onUpdate),
    [ids.length, onDelete, onUpdate],
  );

  return show ? (
    <div
      className={cn(
        // show ? 'max-h-[60px]' : 'max-h-[0px]',
        // 'h-full transition-all duration-200',
        'bg-fill-quarternary px-[14px] py-3',
        'w-[clamp(50%,50vw,100%)] max-w-[848px] rounded-md',
        'flex items-center justify-between',
        'fixed bottom-[25px] left-1/2 transform -translate-x-1/2',
      )}
    >
      <div className="flex items-center gap-1.5">
        <div
          className={cn(
            'w-5 h-5 bg-primary-base rounded',
            'flex items-center justify-center',
          )}
        >
          <p className="text-fill-tertiary font-semibold text-xs">
            {ids.length}
          </p>
        </div>
        <p className="text-fill-tertiary font-semibold text-xs">Selected</p>
      </div>
      <div className="flex gap-3">
        {onMove && (
          <Button
            size="sm"
            intent="secondary"
            className="bg-[#3E4955]"
            label="MOVE DEALS"
            icon={LuMoveUpRight}
            left
            onClick={onMove}
          />
        )}
        {onExport && (
          <Button
            size="sm"
            intent="secondary"
            className="bg-[#3E4955]"
            label="EXPORT"
            icon={ExportIcon}
            left
            onClick={onExport}
          />
        )}
        {onUpdate && (
          <Button
            size="sm"
            intent="secondary"
            className="bg-[#3E4955]"
            label="ASSIGN TAG"
            icon={TagIcon}
            left
            onClick={onUpdate}
          />
        )}
        {onDelete && (
          <Button
            size="sm"
            intent="secondary"
            className="bg-[#3E4955]"
            label="DELETE"
            icon={TrashIcon}
            left
            onClick={onDelete}
          />
        )}
      </div>
    </div>
  ) : (
    <></>
  );
};

export default FloatingBar;
